var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelocateTo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#327DFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.7 14c0 .2.2.4.4.4h3.8c.2 0 .3-.1.3-.3v-.8c0-.2-.1-.4-.3-.4l-1.7.1 6.5-6.6c.1-.1.1-.3 0-.4l-.5-.5c-.1-.1-.3-.1-.4 0l-6.5 6.5.1-1.7c0-.2-.2-.3-.4-.3h-.8c-.2 0-.3.1-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.3 11.5-.6.5s-.1.1-.1.2v4.5c0 .1-.1.1-.1.1h-8c-.1 0-.1 0-.1-.1v-8c0-.1 0-.1.1-.1h7.1c.3 0 .4-.3.2-.5l-.6-.6s-.1-.1-.2-.1h-6.6c-.7.1-1.2.6-1.2 1.2v8.2c0 .6.5 1.1 1.1 1.1h8.2c.6 0 1.1-.5 1.1-1.1v-5.2c0-.1-.2-.2-.3-.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocateTo);
export default __webpack_public_path__ + "static/media/Relocate-To.3d44d6caba957e659f17c21c629f9278.svg";
export { ForwardRef as ReactComponent };